export const visit = (vm, at) => {
at({ "es": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Aumenta de nivel" ), " para ejecutar esta acci\xF3n." ); } } } });
};